module.exports = __webpack_public_path__ + "themes/mf/img/star@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/star@2x.png
// module id = 111
// module chunks = 3